//react
import React, { Component } from 'react';

//components
import ButtonCulture from '../../components/buttonCulture/buttonCulture';

//data
import dataSiteMap from '../../siteMap.json';
import dataExternalSites from '../../externalSites.json';

//assets
import './navCulture.css';

class NavCulture extends Component {
	constructor() {
		super();

		this.state = {
			buttonHeight: 0,
			navOpen: false,
		};

		this.navClose = this.navClose.bind(this);
		this.navToggle = this.navToggle.bind(this);
	}

	componentDidMount() {
		document.addEventListener('click', this.navClose);

		if (this.refs.navCultureButton) {
			this.setState({
				buttonHeight: this.refs.navCultureButton.clientHeight,
			});
		}
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.navClose);
	}

	navClose(event) {
		if (event.target !== this.refs.navCultureButton) {
			this.setState({
				navOpen: false,
			});
		}
	}

	navToggle() {
		this.setState({
			navOpen: !this.state.navOpen,
		});
	}

	render() {
		try {
			let cultureDataSelected = {};
			const cultureDataUnselected = [];

			for (const culture of Object.keys(dataSiteMap)) {
				if (culture === this.props.culture) {
					cultureDataSelected = {
						cultureCode: culture,
						cultureName: dataSiteMap[culture].cultureName,
					};
				} else {
					if (dataSiteMap[culture].live && dataSiteMap[culture].cultureCode !== 'global') {
						cultureDataUnselected.push({
							cultureCode: culture,
							cultureName: dataSiteMap[culture].cultureName,
							external: false,
						});
					}
				}
			}

			for (const culture of Object.keys(dataExternalSites)) {
				if (dataExternalSites[culture].live) {
					cultureDataUnselected.push({
						cultureCode: culture,
						cultureName: dataExternalSites[culture].cultureName,
						external: dataExternalSites[culture].url,
					});
				}
			}

			const cultureList = cultureDataUnselected.sort((a, b) => {return a.cultureName.localeCompare(b.cultureName)}).map((record, index) => {
				const buttonHeight = this.state.buttonHeight;
				let buttonCultureStyles = {};

				if (!this.state.navOpen) {
					buttonCultureStyles = {opacity: 0, pointerEvents: 'none', transform: 'translateY(-' + (buttonHeight + (buttonHeight * index)) + 'px)'};
				}

				return (
					<ButtonCulture culture={this.props.culture} cultureCode={record.cultureCode} external={record.external} key={index} label={record.cultureName} onClick={this.navToggle} pageNotFound={this.props.pageNotFound} style={buttonCultureStyles} />
				);
			});

			let buttonCultureClass = 'button-culture button-culture--nav hwa';

			if (this.props.contentPage) {
				buttonCultureClass += ' button-culture--content-page';
			}

			let listClass = '';

			if (!this.state.navOpen) {
				listClass = 'nav-culture__list--hidden';
			}

			return (
				<div className="nav-culture" ref="navCulture">
					<div className="nav-culture__button-wrapper">
						<button className={buttonCultureClass} onClick={() => this.navToggle()} ref="navCultureButton">
							<div className="button-culture__label">{cultureDataSelected.cultureName}</div>
							<div className="button-culture__flag">
								<img alt={cultureDataSelected.cultureName + ' flag'} className="button-culture__flag__image" src={require('../buttonCulture/' + cultureDataSelected.cultureCode + '.png')} />
							</div>
						</button>
					</div>
					<div className={`nav-culture__list ${listClass}`}>
						{cultureList}
					</div>
				</div>
			);
		} catch(error) {
			console.log('No culture navigation within this culture');

			return null;
		}
	}
}

export default NavCulture;



// WEBPACK FOOTER //
// ./src/components/navCulture/navCulture.js